exports.ACTIVECAMPAIGN = 'activecampaign'
exports.AGILIRON = 'agiliron'
exports.AMAZON = 'amazon'
exports.APPSTLE_SUBSCRIPTIONS = 'appstle_subscriptions'
exports.AUTHORIZE_NET = 'authorize.net'
exports.BASKHEALTH = 'baskhealth'
exports.BUYGOODS = 'buygoods'
exports.BUCKET_IO = 'bucket.io'
exports.CARTPANDA = 'cartpanda'
exports.CLICKFUNNELS = 'clickfunnels'
exports.CLICKBANK = 'clickbank'
exports.COMMITTED = 'committed'
exports.CONVERTBOX = 'convertbox'
exports.CUSTOM = 'custom'
exports.DIGISTORE24 = 'digistore24'
exports.DROPFUNNELS = 'dropfunnels'
exports.EASYWEBINAR = 'easywebinar'
exports.EVERFLOW = 'everflow'
exports.EXPLODELY = 'explodely'
exports.HIGHLEVEL = 'highlevel'
exports.HYROS = 'hyros'
exports.JVZOO = 'jvzoo'
exports.KAJABI = 'kajabi'
exports.KARTRA = 'kartra'
exports.KEAP = 'keap'
exports.KIT = 'kit'
exports.KONNEKTIVE = 'konnektive'
exports.LOOP_SUBSCRIPTIONS = 'loop_subscriptions'
exports.MAILWIZZ = 'mailwizz'
exports.MAROPOST = 'maropost'
exports.MAXWEB = 'maxweb'
exports.MERCHANT_ONE = 'merchant_one'
exports.ONTRAPORT = 'ontraport'
exports.OTHER = 'other'
exports.PAYPAL = 'paypal'
exports.RECHARGE = 'recharge'
exports.SAMCART = 'samcart'
exports.SENDY = 'sendy'
exports.SHOPIFY = 'shopify'
exports.SHOPIFY_JOURNEY = 'shopify_journey'
exports.SKIO_SUBSCRIPTIONS = 'skio_subscriptions'
exports.STICKY = 'sticky'
exports.VIDALYTICS = 'vidalytics'
exports.STRIPE = 'stripe'
exports.TENX_CRM = '10x_crm'
exports.THIIO = 'thiio'
exports.THRIVECART = 'thrivecart'
exports.TUNE = 'tune'
exports.TYPEFORM = 'typeform'
exports.ULTRACART = 'ultracart'
exports.VOLUUM = 'voluum'
exports.WARRIORPLUS = 'warriorplus'
exports.WEBFORCE = 'webforce'
exports.WOOCOMMERCE = 'woocommerce'
exports.WORDPRESS = 'wordpress'